import React, { ReactElement } from 'react'
import colors from '../../styles/_colors.module.scss'
import {IconProps} from "../types";

const MinusIcon = (
    {
        size = 24,
        inheritFill,
        color = colors.text,
    }: IconProps
): ReactElement => {
    const strokeWidth = 5
    const strokeStyle = {
        strokeWidth,
        fill: 'none',
        ...inheritFill
            ? {}
            : {stroke: color},
    }
    return (
        <svg width={size} height={size} viewBox="0 0 50 50">
            <circle cx={25} cy={25} r={25 - strokeWidth} {...strokeStyle} />
            <line
                x1={10 + strokeWidth}
                x2={40 - strokeWidth}
                y1={25}
                y2={25}
                {...strokeStyle}
            />
        </svg>
    )
}

export { MinusIcon }
